module.exports = __webpack_public_path__ + "img/story011.1e96e52f.png";